import { render, staticRenderFns } from "./CollapseItem.vue?vue&type=template&id=a5e4a5e2&scoped=true&"
import script from "./CollapseItem.vue?vue&type=script&lang=js&"
export * from "./CollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./CollapseItem.vue?vue&type=style&index=0&id=a5e4a5e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e4a5e2",
  null
  
)

component.options.__file = "CollapseItem.vue"
export default component.exports